import React from 'react';
import { INITIAL_QUARTERMASTER_STATE } from './quartermaster-reducer';
import { QMCurrentState } from './types';

export const QMCurrentStateCtx = React.createContext<QMCurrentState>({
	...INITIAL_QUARTERMASTER_STATE,
	setAddPobDrawerOpen: () => undefined,
	setEditPobDrawerOpen: () => undefined,
});
